<template>
  <div class="index">
    <div class="user">
      <div class="msg">
        <img v-if="info.avatarurl" :src="info.avatarurl" alt="" />
        <img v-else src="../../../static/user.png" alt="" />
        <div class="msg-right">
          <div class="username">
            <div>
              {{ info.name }}
              <span class="member">{{
                info.vip == 0
                  ? "非会员"
                  : info.vip == 1
                  ? "会员"
                  : info.vip == 2
                  ? "会员已过期"
                  : ""
              }}</span>
            </div>
            <div class="pay_member" @click="open" v-if="info.vip == 1">立即成为会员</div>
          </div>
          <p>
            企业名称 <span>{{ info.company_name }}</span>
          </p>
          <p>
            手机号码<span>{{ info.phone }}</span>
          </p>
          <p>登录密码<span>已设置</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/index";
export default {
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    this.checkInfo();
  },
  methods: {
    checkInfo() {
      getUserInfo({
        token: localStorage.getItem("token"),
      }).then((res) => {
        this.info = res.data.data;
        localStorage.setItem("userInfo", JSON.stringify(res.data.data));
      });
    },
    open() {
      this.$confirm("是否成为会员?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "提交成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
.el-card__body,
.el-main {
  padding: 0;
}
.index {
  .user {
    height: 180px;
    margin: 0 20px;
    box-sizing: border-box;
    background-color: #fff;
    padding: 20px;
    .username {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .member {
        font-size: 12px;
        background-color: #88a1efd8;
        padding: 2px 6px;
        border-radius: 4px;
      }
      .pay_member {
        font-size: 12px;
        color: #409eff;
        cursor: pointer;
        &:hover {
          color: #8cc5ff;
        }
      }
    }
    .msg {
      background-color: #fafafa;
      height: 140px;
      display: flex;
      img {
        width: 120px;
        height: 120px;
        border-radius: 60px;
        margin: 10px;
      }
      .msg-right {
        width: 300px;
        // background-color: white;
        text-align: left;
        margin: 10px;
        line-height: 30px;
        p {
          display: flex;
          justify-content: space-between;
          // border-bottom: 1px solid rgb(216, 215, 215);
          span {
            color: gray;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
